export function initRules() {
    const ruleCheckBox = document.querySelector('#ruleCheckbox');
    if (ruleCheckBox) {
        ruleCheckBox.addEventListener('change', () => {
            const btn = document.querySelector('#btnToQuestions');
            if (ruleCheckBox.checked) {
                btn.classList.remove('disabled');
            } else {
                btn.classList.add('disabled');
            }
        });
    }
}